<template>
<div></div>
</template>

<script>
export default {
    name: 'LoginHeader'
}
</script>

<style scoped>

</style>
